// extracted by mini-css-extract-plugin
module.exports = {"OffersSlider__addContent":"OffersSlider_OffersSlider__addContent__2WFVC","OffersSlider__partner":"OffersSlider_OffersSlider__partner__1_hsD"};